import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import accountService from "../service-api/accountService";
import skillSetMasterService from "../service-api/skillSetMasterService";

// Initial state
const initialState = {
  data: [],
  activeSkills: [],
  error: null,
  isLoading: true,
};

export const fetchAllSkills = createAsyncThunk(
  "data/fetchAllSkills",
  async () => {
    const response = await skillSetMasterService.fetchAllSkills();
    return response.data;
  }
);

export const fetchAllActiveSkills = createAsyncThunk(
  "data/fetchAllActiveSkills",
  async () => {
    const response = await skillSetMasterService.fetchAllActiveSkills();
    return response.data;
  }
);

export const addNewSkill = createAsyncThunk(
  "data/addNewSkill",
  async ({ obj }, { dispatch }) => {
    const response = await skillSetMasterService.addNewSkill(obj);
    dispatch(fetchAllSkills());
    return response.data;
  }
);

export const updateSkill = createAsyncThunk(
  "data/AddNewSkill",
  async ({ id, obj }, { dispatch }) => {
    const response = await skillSetMasterService.updateSkill(id, obj);
    dispatch(fetchAllSkills());
    return response.data;
  }
);

// Create slice
const skillSetMasterSlice = createSlice({
  name: "skillSetMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSkills.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllSkills.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(fetchAllSkills.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchAllActiveSkills.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllActiveSkills.fulfilled, (state, action) => {
        state.isLoading = false;
        state.activeSkills = action.payload.value;
      })
      .addCase(fetchAllActiveSkills.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(addNewSkill.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addNewSkill.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(addNewSkill.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default skillSetMasterSlice.reducer;
